"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReserveDependentProperties = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const getReserveDependentProperties = ({ cashReportWithoutReserve, contributingAccounts, borrowingBaseReserveAmount, fundingConfiguration: { isBorrowingBaseReservePositiveExcessCollectionsOverReserve, }, }) => {
    // Set properties that will be mutated as calculations occur
    let totalPreAdvanceCashContribution = cashReportWithoutReserve.totalEligibleBorrowingBaseAccountCash;
    let reserveAdjustedCollectionsCash = cashReportWithoutReserve.totalCollectionsAccountCash;
    // 1: Reducing eligible cash amounts (1) by borrowing base reserve amount, depending on collections account
    if (borrowingBaseReserveAmount) {
        // Subtract out base collections account amount before adding back in the adjusted value
        // Breaking this up rather than single equation so we then have proper "reserveAdjustedCollectionsCash" for step (3)
        totalPreAdvanceCashContribution -= reserveAdjustedCollectionsCash;
        const collectionsReserveAdjustment = reserveAdjustedCollectionsCash - borrowingBaseReserveAmount;
        reserveAdjustedCollectionsCash = isBorrowingBaseReservePositiveExcessCollectionsOverReserve
            ? Math.max(collectionsReserveAdjustment, 0)
            : collectionsReserveAdjustment;
        totalPreAdvanceCashContribution += reserveAdjustedCollectionsCash;
    }
    // 2: Calculate cash amount that contributes to borrowing base
    // Only care about borrowing base contribution accounts (balance * advance rate)
    // Keep in mind collections contribution can be negative due to reserve, so ignore advance rate in those scenarios
    // Note that this is based on the fact that there's only one collections account per borrowing base,
    // thus being able to assume singular relation between updated collections account cash * advance rate
    const totalCashBorrowingBaseAmount = contributingAccounts.reduce((total, cashAccount) => {
        const { accountType, balance, cashAdvanceRate } = cashAccount;
        const updatedCashAdvanceRate = cashAdvanceRate ?? 0;
        if (accountType === finley_types_1.Bank.BorrowerAccountType.Collections) {
            if (reserveAdjustedCollectionsCash < 0) {
                return total + reserveAdjustedCollectionsCash;
            }
            return total + reserveAdjustedCollectionsCash * updatedCashAdvanceRate;
        }
        return total + balance * updatedCashAdvanceRate;
    }, 0);
    // 3: Calculate effective (weighted average) advance rate
    const effectiveCashAdvanceRate = common_1.utils.divideByOrZero(totalCashBorrowingBaseAmount, totalPreAdvanceCashContribution);
    return {
        totalPreAdvanceCashContribution,
        totalCashBorrowingBaseAmount,
        effectiveCashAdvanceRate,
    };
};
exports.getReserveDependentProperties = getReserveDependentProperties;
//# sourceMappingURL=reserve.js.map